/**
 * Accepts a URL or hostname, and returns it in a clean and consistent format for use in cookie domain options
 *
 * The returned leading `.` is important for domains used in cookies to match up properly
 *
 * If the given url/host/path is relative or undefined, we'll return an undefined domain to trigger default same-domain cookie behavior
 */
var getCleanCookieDomain = function (urlOrHost) {
    // if we receive nothing, return nothing and rely on default behavior of setting the current domain
    if (typeof urlOrHost === 'undefined') {
        return undefined;
    }
    // if we get the wrong kind of value, return undefined
    if (typeof urlOrHost !== 'string') {
        return undefined;
    }
    // if the given path is relative, then we can rely on default behavior of setting the current domain
    if (urlOrHost.startsWith('/')) {
        return undefined;
    }
    // If we're already in the proper format, pass on through
    if (urlOrHost.startsWith('.')) {
        return urlOrHost;
    }
    var hostname = '';
    // removing port from url beucase when we use with `new URL` it doesn't return hostname
    var urlPortRegex = /:[0-9]{1,}/;
    var clearUrlOrHost = urlOrHost.split(urlPortRegex)[0];
    try {
        hostname = new URL(clearUrlOrHost).hostname;
    }
    catch (_a) {
        // if the URL is not complete enough to load into URL, treat it like a hostname itself
        // slice off any path so we have only top-level hostname
        hostname = clearUrlOrHost.split('/')[0];
    }
    if (hostname.includes('invitae.com')) {
        // if we're in prod, return `.invitae.com`
        return ".".concat(hostname.split('.').slice(-2).join('.'));
    }
    else {
        // anywhere else (locusdev), return 3 levels i.e. `.dev.locusdev.net`
        return ".".concat(hostname.split('.').slice(-3).join('.'));
    }
};

export { getCleanCookieDomain };
//# sourceMappingURL=domain.esm.js.map
